import { useCallback } from 'react';
import { prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { useNavigate } from '@core/js/hooks/navigate';
import { useAppSelector } from '@core/js/store/hooks';
import { storageService } from '@core/js/services/storage.service';

// TODO need removed this file after Core Merge 24.7.4.0

export const useNavigateFromLaunchGamePath = () => {
    const location = useLocation();
    const rootPage = useAppSelector(prop('rootPage'));
    const navigateWithReplace = useNavigate({ replace: true });
    const { prevPath } = location.state as { prevPath: string } || {};

    return useCallback(() => {
        const gamesPageUrl = storageService.session.getItem('gamesPageUrl');

        storageService.session.removeItem('gamesPageUrl');

        navigateWithReplace(gamesPageUrl || prevPath || rootPage);
    }, [prevPath, rootPage, navigateWithReplace]);
};
